import { render, staticRenderFns } from "./PendingReseller.vue?vue&type=template&id=08dda788&scoped=true&"
import script from "./PendingReseller.vue?vue&type=script&lang=js&"
export * from "./PendingReseller.vue?vue&type=script&lang=js&"
import style0 from "./PendingReseller.vue?vue&type=style&index=0&id=08dda788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dda788",
  null
  
)

export default component.exports